module.exports = __webpack_public_path__ + "static/media/bowoot_icon.ec648f92.png";